var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilterIconBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  fillRule: "evenodd",
  d: "m6.092 6.396.003.002A3.76 3.76 0 0 1 7.35 9.2v3.696l1.296-.864V9.199c0-1.07.457-2.093 1.26-2.804l.001-.002 2.563-2.28a4.06 4.06 0 0 0 1.212-1.946H2.314a4.06 4.06 0 0 0 1.212 1.947zm7.486-1.037-2.566 2.282a2.08 2.08 0 0 0-.699 1.558v3.41a.59.59 0 0 1-.262.488l-2.701 1.8-.757.505a.586.586 0 0 1-.91-.488V9.199c0-.593-.255-1.16-.699-1.558L2.418 5.36A5.72 5.72 0 0 1 .5 1.086C.5.762.762.5 1.086.5h13.828a.58.58 0 0 1 .582.586c0 1.63-.699 3.188-1.918 4.273",
  clipRule: "evenodd"
})));
export default SvgFilterIconBlack;